import { styled } from '@/stitches.config';

const StyledPill = styled('button', {
  background: '$white',
  border: '1px solid $darkGray700',
  color: '$darkGray200',
  cursor: 'pointer',
  fontSize: '$md',
  fontWeight: '$medium',
  padding: '$2 $4',
  '&:hover': {
    background: '$coolGray300',
  },
  variants: {
    selected: {
      true: {
        background: '$coolGray300',
        color: '#373837',
        fontWeight: '$bold',
      },
    },
  },
});

export const StyledLeftPill = styled(StyledPill, {
  borderRadius: '$togglePillLeft',
  borderRight: 'none',
});

export const StyledRightPill = styled(StyledPill, {
  borderRadius: '$togglePillRight',
});
